import { LANGUAGES } from "@/constants/LangConstants"
import TawkMessenger from "@tawk.to/tawk-messenger-react"
import { ECardType, ICard, setConfigUrls, TopUpContext, useClientApp, useLang } from "@usher/pe-client-front-end-lib"
import { useState } from "react"
import { IntlProvider } from "react-intl"
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"
import { LogoutPopup } from "./components/common/LogoutPopup"
import { Layout } from "./components/Layout"
import { Loading } from "./components/Loading"
import { TwoFactorGuard } from "./components/two-factor/Guard"
import { useMediaQuery } from "./hooks/useMediaQuery"
import { CardsPage, DashboardPage, PayoutsPage, TransactionsPage, VerificationsPage } from "./pages"

import { Iban } from "./pages/Dashboard/IBAN"
import { SettingsPage } from "./pages/Dashboard/SettingsPage"
import { Topup } from "./pages/Topup"

setConfigUrls({
  HOME: process.env.REACT_APP_PATH_HOME,
  CLIENT: process.env.REACT_APP_PATH_CLIENT,
  PAY: process.env.REACT_APP_PATH_PAY!,
  SECURE: process.env.REACT_APP_PATH_SECURE!,
})
const isDev = window.location.hostname === "localhost"
export const App = () => {
  const isMobile = useMediaQuery("(max-width: 440px)")
  const [cardType, setCardType] = useState<ECardType | null>(null)
  const [card, setCard] = useState<ICard | null>(null)
  const { isInitialized } = useClientApp({})
  const { locale, basename, messages } = useLang({
    languages: LANGUAGES,
    folder: process.env.PUBLIC_URL,
  })

  if (!isInitialized || locale === "") return <Loading />
  return (
    <IntlProvider locale={locale} messages={messages} onError={() => {}}>
      <TopUpContext.Provider value={{ cardType, setCardType, setCard, card }}>
        <ToastContainer autoClose={4000} hideProgressBar position={isMobile ? "top-center" : "top-right"} limit={isMobile ? 2 : 5} />
        <LogoutPopup />
        {!isDev && <TawkMessenger propertyId="687a57f3a34206191804351f" widgetId="1j0euf4ad" />}
        <Router basename={basename}>
          <Layout>
            <TwoFactorGuard>
              <Switch>
                <Route path="/" exact component={DashboardPage} />
                <Route path="/transactions" component={TransactionsPage} />
                <Route path="/verifications/:type" component={VerificationsPage} />
                <Route path="/cards" component={CardsPage} />
                <Route path="/settings" component={SettingsPage} />
                <Route path="/payouts" component={PayoutsPage} />
                <Route path="/topup" component={Topup} />
                <Route path="/iban" component={Iban} />
                <Route path={basename.split("/")[0]} render={() => <Redirect to="/" />} />
                <Route path="*" render={() => <h1>Not found</h1>} />
              </Switch>
            </TwoFactorGuard>
          </Layout>
        </Router>
      </TopUpContext.Provider>
    </IntlProvider>
  )
}
